import { ChangeEvent } from "react";
import { Box } from "@mui/material";
import { FirestoreInventoryItemProps } from "types/auth";
import CheckboxInputField from "components/input/checkboxInputField";
import Selector from "components/select/selector";
import { useTranslation } from "utils/locales/utilityFunctions";

export type InventoryCertificationTag = keyof NonNullable<
  FirestoreInventoryItemProps["certificationNumbers"]
>;

type RawWoodInputInformationCertificationFieldProps = {
  tag: InventoryCertificationTag;
  label: string;
  selected: boolean;
  value: string;
  placeholder: string;
  claim?: string | null;
  claimOptions?: readonly string[];
  showCertificateNumberInput: boolean;
  disabled: boolean;
  onToggle: (tag: InventoryCertificationTag) => void;
  onValueChange: (tag: InventoryCertificationTag, value: string) => void;
  onClaimChange: (tag: InventoryCertificationTag, value: string) => void;
};

const RawWoodInputInformationCertificationField = ({
  tag,
  label,
  selected,
  value,
  placeholder,
  claim,
  claimOptions,
  showCertificateNumberInput,
  disabled,
  onToggle,
  onValueChange,
  onClaimChange,
}: RawWoodInputInformationCertificationFieldProps) => {
  const { translate } = useTranslation();
  const hasClaimOptions = Boolean(claimOptions?.length);
  return (
    <CheckboxInputField
      label={label}
      selected={selected}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      showInput={showCertificateNumberInput && selected}
      inputBefore={
        hasClaimOptions ? (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Selector
              title={translate("input-dialog-raw-wood-tab-information-certification-claim")}
              value={claim || ""}
              options={claimOptions!.map((option) => ({
                id: option,
                label: translate(`input-dialog-raw-wood-tab-information-certification-claim-${option}`),
              }))}
              label={true}
              fullWidth={true}
              disabled={disabled}
              changeHandler={(event) => onClaimChange(tag, event.target.value)}
            />
          </Box>
        ) : undefined
      }
      labelWidth={104}
      onToggle={() => onToggle(tag)}
      onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
        onValueChange(tag, event.target.value)
      }
    />
  );
};

export default RawWoodInputInformationCertificationField;
